export default class detailUpdate{
    constructor(kv){

        this.kv = kv;

    }

    /* ---------------------------------------------------

     -- current prev nextのアップデート

    --------------------------------------------------- */

    set(){

        //remove
        if(this.kv.detail.querySelector('.is-current')) {
            this.kv.detail.querySelector('.is-current').classList.remove("is-current");
        }
        if(this.kv.detail.querySelector('.is-prev')){
            this.kv.detail.querySelector('.is-prev').classList.remove("is-prev");
        }
        if(this.kv.detail.querySelector('.is-next')){
            this.kv.detail.querySelector('.is-next').classList.remove("is-next");
        }

        for(let i=0; this.kv.detailContent.length>i; i++) {
            if(i === this.kv.status.index){
                this.kv.detailContent[i].classList.add("is-current");
            }
            else if(this.kv.status.index > 0 && i === this.kv.status.index-1){
                this.kv.detailContent[i].classList.add("is-prev");
            }else if(this.kv.status.index < this.kv.max && i === Number(this.kv.status.index)+1){
                this.kv.detailContent[i].classList.add("is-next");
            }else{
                TweenMax.set(this.kv.detailContent[i] ,{
                    opacity:0,
                    display:'none'
                });
            }
        }

        //btn
        this.kv.detailPrevBtn.className = "";
        this.kv.detailNextBtn.className = "";
        if(this.kv.status.index > 0){
            let _num = Number(this.kv.status.index)-1;
            this.kv.detailPrevBtn.className = "number"+_num;
        }else{
            this.kv.detailPrevBtn.className = "number17";
        }
        if(this.kv.status.index < this.kv.max){
            let _num = Number(this.kv.status.index)+1;
            this.kv.detailNextBtn.className = "number"+_num;
        }else{
            this.kv.detailNextBtn.className = "number0";
        }

        if(this.kv.param.userAgent === 'pc'){

            let _number;
            let _Index = Number(this.kv.status.index)+1;

            if(_Index <= 9){
                _number = '<span>0</span><span>'+String(_Index)+'</span>';
            }else{
                _number = String(Number(this.kv.status.index)+1).split('');
                _number = '<span>'+_number[0]+'</span><span>'+_number[1]+'</span>';
            }

            TweenMax.staggerTo(this.kv.pagerNow.children, .3 , {
                y: '-100%',
                ease: this.kv.easeBack,
                onComplete: () => {
                    this.kv.pagerNow.innerHTML = _number;
                    TweenMax.staggerFromTo(this.kv.pagerNow.children, .6, {
                        y: '100%',
                    }, {
                        y: '0%',
                        ease: this.kv.easeBack,
                    }, 0.05);
                }
            });
        }

    }

    remainingSet(){

        let _number = '<span>1</span><span>8</span>';

        for(let i=0; this.kv.detailContent.length>i; i++) {
            this.kv.detailNumber[i].innerHTML = _number;
        }

        TweenMax.staggerTo(this.kv.pagerNow.children, .3 ,{
            delay:2.4,
            y:'-100%',
            ease: this.kv.easeBack,
            onComplete:() =>{
                TweenMax.to(this.kv.pager, .3, {
                    scale: 1,
                    opacity: 1,
                    display: 'block',
                    ease: this.kv.easeBack,
                });
                this.kv.pagerNow.innerHTML = _number;
                TweenMax.staggerFromTo(this.kv.pagerNow.children, .6 , {
                    y: '100%',
                },{
                    y: '0%',
                    ease: this.kv.easeBack,
                },0.05);
            }
        },0.05);

    }

    remaining(){

        let _number;
        let _delay = 0;
        this.kv.shuffleRepeat = new TimelineMax({repeat:-1});

        if(window.mv_main.itemNum <= 9){
            _number = '<span>0</span><span>'+String(window.mv_main.itemNum)+'</span>';
        }else{
            _number = String(window.mv_main.itemNum).split('');
            _number = '<span>'+_number[0]+'</span><span>'+_number[1]+'</span>';
        }

        if(window.mv_main.itemNum === 18){
            _delay = 2.7;
        }

        for(let i=0; this.kv.detailContent.length>i; i++) {
            this.kv.detailNumber[i].innerHTML = _number;
        }

        TweenMax.staggerTo(this.kv.pagerNow.children, .3 ,{
            delay:_delay,
            y:'-100%',
            ease: this.kv.easeBack,
            onComplete:() =>{
                TweenMax.to(this.kv.pager, .3, {
                    scale: 1,
                    opacity: 1,
                    display: 'block',
                    ease: this.kv.easeBack,
                });
                if(window.mv_main.itemNum === 0){
                    this.kv.shuffleRepeat.set(this.kv.shuffle, {
                        display: 'block',
                    });
                    TweenMax.to(this.kv.pager, .3 , {
                        scale: 0.8,
                        opacity: 0,
                        ease: this.kv.easeBack,
                    });
                    if(this.shuffleRepeat){
                        this.shuffleRepeat.play();
                    }else{
                        this.kv.shuffleRepeat.to(this.kv.shuffle, 1.3 , {
                            opacity: 1,
                            ease: Power0.easeNone,
                        }).to(this.kv.shuffle, 1.3 , {
                            opacity: 0,
                            ease: Power0.easeNone,
                        }).set(this.kv.shuffle , {
                            className: "+=type-color",
                        }).to(this.kv.shuffle, 1.3 , {
                            opacity: 1,
                            ease: Power0.easeNone,
                        }).to(this.kv.shuffle, 1.3 , {
                            opacity: 0,
                            ease: Power0.easeNone,
                        }).set(this.kv.shuffle , {
                            className: "-=type-color",
                        });
                    }
                }else{
                    this.kv.pagerNow.innerHTML = _number;
                    TweenMax.staggerFromTo(this.kv.pagerNow.children, .6 , {
                        y: '100%',
                    },{
                        y: '0%',
                        ease: this.kv.easeBack,
                    },0.05);
                }
            }
        },0.05);
    }


}